<template>
  <div id="wrapper">
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <div class="container-fluid">
          <p style="margin-bottom:50px"></p>
          <h3 class="text-dark mb-4 text-center"><strong>Benvenuto</strong></h3>
          <div class="row mb-3">
            <div class="col-lg-8">
              <div class="row">
                <div class="col-lg-12 offset-lg-3" style="width: 500">
                  <div class="card shadow mb-3">
                    <div class="card-header py-3">
                      <p class="text-primary m-0 font-weight-bold"><br /></p>
                    </div>
                    <div class="card-body">
                      <h4><strong>ACCEDI</strong></h4>
                      <div class="form-row">
                        <div class="col">
                          <div class="form-group">
                            <label for="Username_db"><strong>Username</strong></label>
                            <input  class="form-control" type="text" placeholder="username" name="username_db" v-model="username" required v-on:keyup.enter="login()"/>
                            <label for="Password_db"><strong>Password</strong><br/></label>
                            <input class="form-control" type="password" placeholder="password" name="password_db" v-model="password" required v-on:keyup.enter="login()"/>
                            <input type="hidden" id="Id_negozio" name="Id_negozio" /><br />
                          </div>
                          <div class="form-group">
                            <button class="btn" style="background: #00467f" type="submit" v-on:click="login()">Accedi</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
          </div>
          <div class="card shadow mb-5"></div>
        </div>
        <b-modal v-model="showCredential"  size="md">
        <template #modal-header="{ close }">
          <b-button @click="close()">X</b-button>
        </template>
        <template>
          <h3 style="color:black; text-align:center; margin-top:15px">Credenziali non valide!</h3>
        </template>
        <template #modal-footer="{ cancel }">
          <span style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()" v-on:click="cancelCheckCredential()">CHIUDI</b-button></span>
          <!--<span style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="ok()">OK</b-button></span>-->
        </template>
      </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  components: {},

  data() {
    return {
      username: "",
      password: "",
      showCredential: false,
      header: {
        headers: {
          "Content-type": "application/json "
        }
      },
      results: "",
      urlRichieste: "https://sviluppoallergeni.confcom.it/" //'https://apiintranet.confcom.it/'
    };
  },
  methods: {
    login: async function() {
      let datiInviare = [];
      datiInviare.push({
        username: this.username,
        password: this.password
      });
      let datiJSON = JSON.stringify(datiInviare[0]);
      await axios.post(
          this.urlRichieste + "login",//'https://sviluppoallergeni.confcom.it/login', 
          datiJSON,
          {
            withCredentials: true,
            headers: {
              "Content-type": "application/json"
            }
        }).then(response => {
          this.results = response.data;
        })
        .catch(async function(error) {
          // handle error
          if (error.response.status == 403) {
            //alert("credenziali non valide");
            this.showCredential = true;
          }
        });

      localStorage.setItem("access_token", this.results.accessToken);
      localStorage.setItem("refresh_token", this.results.refreshToken);
      localStorage.setItem("user_id", this.results.user.ID);
      localStorage.setItem("user_email", this.results.user.EMAIL);
      localStorage.setItem("user_nome", this.results.user.NOME);
      localStorage.setItem("user_cognome", this.results.user.COGNOME);
      localStorage.setItem("user_livello", this.results.user.LIVELLO);
      localStorage.setItem("user_tipologia", this.results.user.TIPOLOGIA);
      localStorage.setItem("isLogged", true);
      this.$router.push({
        path: "/dashboard"
      });
      //location.reload();
    },

    cancelCheckCredential: function() {
      this.showCredential= false;
    },

    main: function() {
      axios.defaults.withCredentials = true;
    }
  },

  mounted() {
    this.main();
  },

  beforeMount: function() {}
};
</script>

<style></style>
